import { createSlice } from '@reduxjs/toolkit'
import { getMessage } from '../../../helpers/Messages'

const initialState = {
    isRegistering: false,
    registerError: false,
    message: '',
    errors: '',
    permissionsTier: false,
    isVerified: false
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        requestRegister: (state) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes

            state.isRegistering = true
            state.registerError = false
        },
        registerSuccess: (state) => {
            state.isRegistering = false
            state.registered = true
            state.message = getMessage('registerSuccess')
        },
        registerError: (state, action) => {
            state.isRegistering = false
            state.registered = false
            state.registerError = true
            state.message = action.payload || getMessage('error')
        },
        resetUsers: (state) => initialState,
        setPermissionsTier: (state, action) => {
            state.permissionsTier = action.payload
        },
        setVerified: (state, action) => {
            state.isVerified = action.payload
        },
        setMessage: (state, action) => {
            state.message = action.payload || ''
        },
    },
})

// Action creators are generated for each case reducer function
export const {
    requestRegister,
    registerSuccess,
    registerError,
    resetUsers,
    setPermissionsTier,
    setMessage,
    setVerified
} = userSlice.actions

export default userSlice.reducer
